import PropTypes from 'prop-types';
function TeacherStatsDonors({ isTeacher, numLifetimeDonors, teacherPossessiveScreenName }) {
    if (numLifetimeDonors === 0) return null;

    function textCopy() {
        return `Donors who've supported ${isTeacher ? 'your' : teacherPossessiveScreenName} classroom`;
    }

    return (
        <section className='donorsWrapper'>

            <h3>{textCopy()}</h3>
            <div className='donor-heart'>

                <div className='donor-sparks'>
                    <img alt='' className='illustration' src='../../../images/teacher/stats/illu_spark.svg'/>
                    <img alt='' className='illustration' src='../../../images/teacher/stats/illu_spark.svg'/>
                    <img alt='' className='illustration' src='../../../images/teacher/stats/illu_spark.svg'/>
                    <img alt='' className='illustration' src='../../../images/teacher/stats/illu_spark.svg'/>
                    <img alt='' className='illustration' src='../../../images/teacher/stats/illu_spark.svg'/>
                    <img alt='' className='illustration' src='../../../images/teacher/stats/illu_spark.svg'/>
                </div>

                <h2>{numLifetimeDonors}</h2>
            </div>

        </section>

    );
}

TeacherStatsDonors.propTypes = {
    isTeacher: PropTypes.bool.isRequired,
    numLifetimeDonors: PropTypes.number.isRequired,
    teacherPossessiveScreenName: PropTypes.string.isRequired,
};

export default TeacherStatsDonors;
